<div class="layout-header px-md-4 px-2 py-2 border-bottom d-flex justify-content-between align-items-center" style="background-color: #ffffff;">
  <div class="header-right d-flex justify-content-center align-items-center">
    <div class="search-bar position-relative d-flex">
      <img src="assets/images/icons/hamburger-menu.svg" alt="" class="d-xl-none me-2" (click)="openNavMenu()">
      <!-- <input type="text" class="input_field py-1 pe-3" placeholder="Search Here" [(ngModel)]="search_string" (change)="emitSeacrh()"> -->

    </div>
    <div class="two-tabs d-flex align-items-center gap-3">
      <p *ngIf="+userProfile?.role_id !== 5" [routerLink]="['/app/integration']" routerLinkActive="router-link-active">Integration</p>
      <p [routerLink]="['/app/profile']" routerLinkActive="router-link-active">Settings</p>
      <p [routerLink]="['/app/support']" routerLinkActive="router-link-active">Help & Support</p>
    </div>
  </div>
  <div class="header-left d-flex justify-content-center align-items-center position-relative gap-4">
    <!-- <button class="btn btn-success p-3 me-3" style="background-color: #5486e4 !important" *ngIf="!quickbooksIntegrated" (click)="connect()">Connect quickbooks</button>
    <span class="btn btn-success p-3 me-3" style="background-color: #5486e4 !important;" *ngIf="quickbooksIntegrated">Quickbooks integrated</span> -->

    <!-- <button (click)="getCustomersList()">Get List</button> -->
    <!-- <button class="btn btn-primary fs-16 fw-600 me-3" [routerLink]="'finance/payment-plans'">Create Contract</button> -->
    <div class="outreach-approval d-flex justify-content-center align-items-center" *ngIf="business_brand_outreach == 1"
      (click)="openPenidngOutreach()">
      <div>
        <img src="../../../assets/images/img/consent-pending.png">
      </div>
    
      <p>Outreach Approval
        <span>PENDING</span>
      </p>
    
    </div>
    <span class="position-relative me-3 d-none">
      <img src="assets/images/icons/bell-icon.svg" alt="" class="notify-bell rounded-circle border cursor"
        (click)="_shared.showNotificationBar = true">
    </span>
    <img [src]="(userProfile && userProfile.doctor_image) || 'assets/images/icons/profile_placeholder.png'"
      style="width: 40px;" alt="" class="profile-icon -rounded-circle border cursor"
      [ngClass]="{'rounded-circle': !userProfile.doctor_image || userProfile.doctor_image == 'assets/images/icons/profile_placeholder.png'}"
      (click)="showLogoutModal()">

    <div class="logout-wrapper p-md-4 p-2 position-absolute bg-white end-0 radius-8" *ngIf="showLogout">
      <div class="logout-header d-flex align-items-center lhc">
        <img [src]="(userProfile && userProfile.doctor_image) || 'assets/images/icons/profile_placeholder.png'"
          style="width: 40px;" alt="" class="business-img -rounded-circle me-3 lhc">

        <div class="lhc">
          <h1 class="fs-16 fw-600 m-0 lhc">
            {{userProfile.doctor_name}}
          </h1>
          <p class="fs-14 fw-400 m-0 lhc">
            {{userProfile.doctor_email}}
          </p>
        </div>

      </div>

      <div class="logout-body mt-3 pt-3 border-top">
        <ul class="p-0">
          <li class="d-flex align-items-center mb-3 cursor" *ngFor="let item of settingsList"
            (click)="userAction(item)">
            <img [src]="item.icon" alt="" class="rounded-circle me-3">
            <p class="fs-16 fw-400 m-0 logout-content">
              {{item.label}}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>